export default __webpack_public_path__ + "static/media/investment.8da037da.png";